import React, { useMemo } from 'react';

import { Form, FormItemProps, FormRule } from 'antd';
import { MaskedInput } from 'antd-mask-input';

import { VEHICLE_PLATE_PATTERN } from './helpers/Domain.helper';

type VehiclePlateFieldProps = {
    help?: FormItemProps['help'],

    /** @default 'vehicle_plate' */
    name?: FormItemProps['name'],

    /** @default 'Placa do veículo' */
    label?: FormItemProps['label'],

    /**
     * @warning Merges with {@link DEFAULT_PATTERN_RULE}
     * @default []
     */
    rules?: FormItemProps['rules'],

    /** @default false */
    loading?: boolean,
}

const DEFAULT_PATTERN_RULE: FormRule = {
    pattern: VEHICLE_PLATE_PATTERN,
    message: 'Por favor, digite uma placa válida.'
};

export function VehiclePlateField({
    help,
    name = 'vehicle_plate',
    label = 'Placa do veículo',
    rules = [],
    loading = false,
}: VehiclePlateFieldProps) {
    const mergedRules = useMemo(() => [DEFAULT_PATTERN_RULE, ...rules], [rules]);
    
    return (
        <Form.Item
            name={name}
            label={label}
            help={help}
            rules={mergedRules}
            normalize={(value: string | null | undefined) => value?.toUpperCase()}
        >
            <MaskedInput
                mask="aaa0[0a]00"
                disabled={loading}
                /**
                 * The Antd `Input` of `MaskedInput` cannot use
                 * the `ConfigProvider` context, so we need to
                 * add the missing - and required - CSS variables manually
                 */
                styles={{
                    input: {
                        '--ant-input-input-font-size': '14px',
                        '--ant-input-padding-block': '4px',
                        '--ant-input-padding-inline': '11px',
                    }
                }}
            />
        </Form.Item>
    );
}
